import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RedEnvelopeFilledSvg from "@ant-design/icons-svg/es/asn/RedEnvelopeFilled";
import AntdIcon from "../components/AntdIcon";
var RedEnvelopeFilled = function RedEnvelopeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RedEnvelopeFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RedEnvelopeFilled.displayName = 'RedEnvelopeFilled';
}
export default /*#__PURE__*/React.forwardRef(RedEnvelopeFilled);